import { render } from "./PessoasAutorizadas.vue?vue&type=template&id=135626ba&scoped=true"
import script from "./PessoasAutorizadas.vue?vue&type=script&lang=js"
export * from "./PessoasAutorizadas.vue?vue&type=script&lang=js"

import "./PessoasAutorizadas.vue?vue&type=style&index=0&id=135626ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135626ba"]])

export default __exports__